import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import { GrEmptyCircle } from "react-icons/gr";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";
import { FaRegTimesCircle } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";
import { IoTriangleOutline } from "react-icons/io5";
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useState } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import Footer from './Common_Components/Footer';
// import { IoCloseOutline } from 'react-icons/io';


const HiraganaQuiz = () => {
  const [activePage, setActivePage] = useState("Learning");
  const now = 40;
  const navigate = useNavigate();
  let customColor;

  if (now < 20) {
    customColor = "green"
  }
  else if (now === 40) {
    customColor = "Blue"
  }
  else if (now < 60) {
    customColor = "yellow"
  }
  else if (now < 80) {
    customColor = "green"
  } else {
    customColor = "green"
  }
  return (
    <div className='Profile_Design_Main_Div_11'>
        <div className='header_inner' >
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <ArrowBackIosIcon onClick={() => navigate('/Learn')} className='icon_1' />
                <h2>Hiragana Quiz</h2>
                <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
              </div>
            </div>
          </div>
        </div>
      

      <div className="hiragana_quiz" style={{ marginTop: "75px", marginBottom: "85px" }}>
        <div className="row">
          <div className="col-md-12">
            {/* <h3 className='mt-4 mb-4 ' style={{textAlign:"left", textDecoration:"underline"}} >N5</h3> */}
            <div className="btn_JLPT">
              <button className='mt-4 mb-4 '>N5</button>
            </div>

            <div className="JLPTQuiz_btn d-flex justify-content-around  p-2 ">
              <Link to={"/QDontTry"} >
                <div className="JLPTQuiz-1 ">
                  <GrEmptyCircle size={30} color='white' />
                </div>
              </Link>
              <Link to={"/QDontTry"} >
                <div className="JLPTQuiz-2 ">
                  <FaRegCircle size={30} color='white' />
                </div>
              </Link>
              <Link to={"/QwantTry"} >
                <div className="JLPTQuiz-3">
                  <IoTriangleOutline size={30} color='white' />
                </div>
              </Link>
              <Link to={"/QwantTry"} >
                <div className="JLPTQuiz-4">
                  <FaRegTimesCircle size={30} color='white' />
                </div>
              </Link>
              <Link to={"/QwantTry"} >
                <div className="JLPTQuiz-5">
                  <HiOutlineDotsCircleHorizontal size={30} color='white' />
                </div>
              </Link>
            </div>
          </div>
          <div className="col-md-12">

            <div className="JLPT_Quiz_Progres_bar mt-3 p-1">
              <p className="progress-text-left">Overall Progress</p>
              <ProgressBar
                now={now}
                label={`${now}%`}
                visuallyHidden
                className="JLPTQuiz_Progress_bar"
              >
                <div className="progress-bar-container">
                  <div className="progress-bar-fill" style={{ width: `${now}%` }} />
                </div>
              </ProgressBar>
              <p className="progress-text-right">Total Attempted: 12</p>
            </div>


          </div>
        </div>
        <div className="container hiragana-read-write-container mt-5 ">

          <div className="row justify-content-center mt-3">
            <div className=" JLPT_Reading col-md-2 me-3 mt-2 mb-2" >
              <Link to={'/ReadingQuiz'} style={{ textDecoration: 'none', color: 'inherit' }} >
                <img src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`} alt="Penguine" className='JLPT_learn_img me-2' /><span className='JLPT_span'>Reading</span>
              </Link>
            </div>

            <div className=" JLPT_Listening col-md-2 mt-2 mb-2">
              <Link to={'/writing-quiz'} style={{ textDecoration: 'none', color: 'inherit' }}  >
                <img src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`} alt="Penguine" className='JLPT_learn_img  me-2' /><span className='JLPT_span'>Writing</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default HiraganaQuiz
